export default "__VITE_ASSET__7K6k2q63__"